const AllocationBy = {
  Submit: 1, // Cân đối
  Audit: 2, // Kiểm tra
};

export default AllocationBy;
